import * as Sentry from "@sentry/nextjs";
import { signIn } from "next-auth/react";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { validateEmail } from "../../../common/helper";
import { SignInProps } from "../../../pages/auth/signin";
import Alert from "../../components/Alert/Alert";

const getClassName = {
    github: "hover:bg-social-github bg-social-github",
    facebook: "hover:bg-social-facebook bg-social-facebook",
    google: "hover:bg-social-google bg-social-google",
};

export default function SignInPage({ providers }: SignInProps) {
    const [emailSent, setEmailSent] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    // const [password, setPassword] = useState("");

    const errorTimeout = useRef(null);

    const router = useRouter();
    const redirectUrl = router.query.redirect as string;

    useEffect(() => {
        if (router?.query?.error) {
            Sentry.captureException(
                "Email adresa je već korištena sa drugim social loginom ili magic linkom."
            );
        }
    }, [router?.query?.error]);

    // const credentialsLogin = async () => {
    //     try {
    //         signIn("credentials", {
    //             callbackUrl: `http://localhost:3000/verify`,
    //             email,
    //             password,
    //         });
    //     } catch (error) {
    //         console.log("r", error);
    //     }
    // };

    const emailLogin = async () => {
        const isValid = validateEmail(email) && !email.includes("+");

        const headers = {
            Accept: "application/json",
        };

        const response = await fetch(
            `https://api.disposable-email-detector.com/api/dea/v1/check/${email}`,
            {
                headers,
            }
        )
            .then((response) => response.text())
            .then((str) =>
                new window.DOMParser().parseFromString(str, "text/xml")
            );

        const isDisposableEmail =
            response.getElementsByTagName("IsDisposable")[0].childNodes[0]
                .nodeValue;

        // console.log("isDisposableEmail", isDisposableEmail);

        if (isDisposableEmail === "true") {
            setError("Ne mozete koristiti temporary email providere.");
            return;
        }

        if (isValid) {
            try {
                setLoading(true);
                const response = await signIn("email", {
                    callbackUrl: process.env.NEXTAUTH_URL,
                    redirect: false,
                    email,
                });
                if (response.status === 200 && response.error === null) {
                    setEmailSent(true);
                } else {
                    Sentry.captureException(response.error);
                    setError(response.error);
                }
                setLoading(false);
            } catch (error) {
                Sentry.captureException(error);
            }
        } else {
            setError(
                email.includes("+")
                    ? "Molimo bez + u emailu, onemogucili smo zbog spama."
                    : "Unesite validan email."
            );
            errorTimeout.current = setTimeout(() => {
                setError("");
            }, 5000);
        }
    };

    return (
        <div className="bg-grey-lighter min-h-screen flex flex-col bg-gray-light">
            <div className="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
                <div className="text-gray-dark mb-4">
                    <p
                        className="no-underline cursor-pointer hover:text-blue"
                        onClick={() => router.back()}
                    >
                        &#8592; Vrati se nazad na stranicu.
                    </p>
                </div>
                <div className="bg-white px-6 py-8 rounded text-black w-full  job-shadow">
                    <h1 className="mb-4 text-3xl text-center">Prijava</h1>
                    <div className="text-center mb-4 bg-blue-superlight py-2 px-4 text-sm text-gray-dark max-w-screen-md m-auto">
                        Registracijom se borimo protiv spama. Vaši korisnički
                        podaci neće biti nigdje vidljivi niti ikome dostupni.
                    </div>
                    {providers &&
                        Object.values(providers)
                            .filter(
                                (p) =>
                                    p.name !== "Credentials" &&
                                    p.name !== "Email"
                            )
                            .map((provider) => (
                                <div key={provider.name}>
                                    <button
                                        className={`btn-primary w-full text-center rounded focus:outline-none hover:bg-opacity-75 my-1 ${
                                            getClassName[provider.id]
                                        }`}
                                        onClick={() =>
                                            signIn(provider.id, {
                                                callbackUrl:
                                                    redirectUrl ||
                                                    process.env.NEXTAUTH_URL,
                                            })
                                        }
                                    >
                                        Prijavi se preko {provider.name}
                                    </button>
                                </div>
                            ))}

                    {!emailSent && (
                        <>
                            <p className="text-center mt-4">
                                ili prijavi se putem email magičnog linka
                            </p>
                            <input
                                type="text"
                                className="block border border-gray w-full p-3 rounded mb-4 mt-4"
                                name="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button
                                type="submit"
                                className="btn-primary w-full text-center py-3 rounded focus:outline-none my-1 disabled:bg-gray-300"
                                onClick={emailLogin}
                                disabled={loading || email === ""}
                            >
                                {loading ? "Šaljem" : "Pošalji magični link"}
                            </button>
                        </>
                    )}
                    {emailSent && (
                        <div className="btn-primary w-full text-center py-3 rounded focus:outline-none my-2 mt-12 bg-green-600 hover:bg-green-600">
                            Login link poslan na email
                        </div>
                    )}
                    {/* <input
                        type="text"
                        className="block border border-gray w-full p-3 rounded mb-4 mt-4"
                        name="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <input
                        type="password"
                        className="block border border-gray w-full p-3 rounded mb-4"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                        type="submit"
                        className="btn-primary w-full text-center py-3 rounded focus:outline-none my-1"
                        onClick={credentialsLogin}
                    >
                        Prijavi se
                    </button> */}

                    <div className="text-center text-sm text-gray-dark mt-4">
                        Registracijom prihvatam{" "}
                        <a className="underline" href="/uslovi" target="_blank">
                            uslove korištenja
                        </a>{" "}
                        i{" "}
                        <a
                            className="underline"
                            href="/privatnost"
                            target="_blank"
                        >
                            politiku privatnosti
                        </a>
                        .
                    </div>
                </div>
            </div>
            {error && <Alert type="error" message={error} />}
            {router?.query?.error && (
                <Alert
                    type="error"
                    message="Email adresa je već korištena sa drugim social loginom ili magic linkom."
                />
            )}
        </div>
    );
}
